<fieldset cdxFieldset legend="{{ label }}" [i18n]="'@@form-title'" [formGroup]="group" layout="large">
	<form-input [formControlName]="formControlName" inputType="number">
		<form-input-error validation [control]="formControlName">
			<p cdxInvalidType="required" i18n="@@dcForm-number-RequiredError">This field is required.</p>
		</form-input-error>
		<form-input-error validation [control]="formControlName">
			<p cdxInvalidType="min" i18n="@@dcForm-number-MinError">Please enter a number greater than {{ min }}.</p>
		</form-input-error>
		<form-input-error validation [control]="formControlName">
			<p cdxInvalidType="max" i18n="@@dcForm-number-MaxError">Please enter a number less than {{ max }}.</p>
		</form-input-error>
	</form-input>
</fieldset>
